const blockModules = import.meta.glob('../../page-builder-view/block-editor/blocks/*.vue', {
    eager: true,
    import: 'default',
});
const localBlockModules = import.meta.glob('./blocks/*.vue', {
    eager: true,
    import: 'default',
});

const normalizeBlockName = (path) => path
    .replace(/^\.\.\/\.\.\/page-builder-view\/block-editor\/blocks\//, '')
    .replace(/^\.\/blocks\//, '')
    .replace(/\.vue$/, '');

export const aiPageBuilderBlocks = [...Object.entries(blockModules), ...Object.entries(localBlockModules)].reduce((ack, [path, component]) => {
    const name = normalizeBlockName(path);
    ack[name] = component;

    return ack;
}, {});

if (aiPageBuilderBlocks['ai-content-video']) {
    aiPageBuilderBlocks.video = aiPageBuilderBlocks['ai-content-video'];
}

export const parseMfComponentConfig = (element) => {
    try {
        return JSON.parse(element.getAttribute('config') || '{}');
    } catch (e) {
        return {};
    }
};
